import type { PageTourDefinition, PageTourStep } from '../../components/tour/pageTourTypes';
import { ROUTES } from '../routes';

/** Pasos del tour en el listado `/ventas/pedidos`. */
const PEDIDOS_LISTADO_STEPS: PageTourStep[] = [
  {
    targetId: 'pedidos-nueva-pos',
    title: 'Nuevo pedido POS',
    body: 'Desde acá cargás un pedido nuevo: elegís cliente, agregás artículos y lo guardás para prepararlo y facturarlo después.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pedidos-filtros',
    title: 'Filtros de búsqueda',
    body: 'Filtrá por número, cliente o CUIT, estado, rango de fechas y sucursal. Con «Pend. de facturar» ves solo los pedidos que falta facturar.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pedidos-kpis',
    title: 'Resumen del período',
    body: 'Estos indicadores resumen cantidad, totales, peso y volumen de los pedidos según los filtros aplicados.',
    placement: 'bottom',
    pad: 4,
  },
  {
    targetId: 'pedidos-grilla',
    title: 'Listado de pedidos',
    body: 'Acá ves los pedidos cargados con su estado. Tocá el comprobante para ver el detalle del pedido.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'pedidos-acciones',
    title: 'Acciones por pedido',
    body: 'Desde cada fila podés imprimir, facturar el pedido o usar el menú ⋮ para conversión automática, marcarlo impreso, enviarlo a picking, marcarlo preparado o anularlo.',
    placement: 'left',
    pad: 6,
  },
];

/** Pasos del tour en el POS `/ventas/pedidos/nuevo-pos`. */
const PEDIDOS_POS_STEPS: PageTourStep[] = [
  {
    targetId: 'pos-cliente',
    title: 'Cliente',
    body: 'Seleccioná el cliente del pedido. Desde el panel podés repetir su último pedido o ver Info 360.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-busqueda',
    title: 'Agregar artículos',
    body: 'Buscá productos por código, descripción o escaneando, y agregalos al pedido. Se habilita al elegir el cliente.',
    placement: 'bottom',
    pad: 6,
  },
  {
    targetId: 'pos-lineas',
    title: 'Artículos del pedido',
    body: 'Editá cantidades, precios y descuentos de cada renglón. Podés duplicar o eliminar líneas según necesites.',
    placement: 'top',
    pad: 4,
  },
  {
    targetId: 'pos-totales',
    title: 'Totales y datos del pedido',
    body: 'Revisá descuentos, IVA y total. Completá fechas de emisión y vencimiento, compañía, vendedor, lista de precios y datos de entrega.',
    placement: 'left',
    pad: 4,
  },
  {
    targetId: 'pos-emitir',
    title: 'Guardar pedido',
    body: 'Cuando esté todo listo, guardá el pedido. Después lo encontrás en el listado para imprimirlo, prepararlo o facturarlo.',
    placement: 'top',
    pad: 8,
  },
];

export const PEDIDOS_LISTADO_TOUR: PageTourDefinition = {
  id: 'pedidos-listado',
  steps: PEDIDOS_LISTADO_STEPS,
  continueTo: `${ROUTES.ventas.pedidos.pos}?tour=1`,
  continueLabel: 'Ir al POS',
  continuePermiso: 'ventas.pedidos.nuevo',
};

export const PEDIDOS_POS_TOUR: PageTourDefinition = { id: 'pedidos-pos', steps: PEDIDOS_POS_STEPS };
